import 'flickity/dist/flickity.pkgd'

var splashSlider = jQuery('.learn__holder'),
    splashSlides = jQuery('.learn__holder .block')

if (splashSlider.length > 0 && splashSlides.length > 1) {

    splashSlider.flickity({
        cellSelector    : '.block',
        prevNextButtons : false,
        wrapAround      : false,
        pageDots        : false,
        cellAlign       : 'left',
        accessibility   : false,
    })
    
    jQuery( '.learn__nav .previous' ).on( 'click', function( e ){
        e.preventDefault()

        splashSlider.flickity('previous')
    })

    jQuery( '.learn__nav .next' ).on( 'click', function( e ){
        e.preventDefault()

        splashSlider.flickity('next')
    })
}
